<template>
  <bill-template-blank-form
    submit-label="Добавить шаблон квитанции"
    :bill-template="bill_template"
    :errors="errors"
    form-type="add"
    @submit="processForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addBillTemplate } from '@/services/bill_template.service'
import billTemplateBlankForm from '@/components/forms/bill_template/BillTemplateBlankForm'

export default {
  name: 'bill-template-add-form',
  components: { billTemplateBlankForm },
  data () {
    return {
      bill_template: {
        id: null,
        file: ''
      },

      errors: {
        bill_template: {
          id: [],
          file: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processForm () {
      this.addBillTemplate().then((success) => {
        if (success) {
          this.showMsg('Шаблон квитанции был успешно добавлен!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addBillTemplate () {
      return addBillTemplate(this.bill_template).then((response) => {
        this.bill_template = response.data
        this.fillErrors(this.errors.bill_template, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.bill_template, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BillTemplateAddForm.vue?0a0ecf6f